import React, { useContext, useEffect, useState } from "react";
import TaxContexts from "../../contexts/tax-contexts";
import moment from "moment";

import { Table, Button, Form, Input, Divider, Col, Row } from "antdV4";
import { Modal, notification, Typography } from "antd";

import * as XLSX from "xlsx-js-style";

const ImportStatusModal = () => {
  const { state, dispatch } = useContext(TaxContexts);
  const importStatusModal = state.modalImportStatus || { visible: false };
  const taxInfo = state.taxInfo || {};
  const pageSize = 20;

  const [importStatusPage, setImportStatusPage] = useState(1);
  const [form] = Form.useForm();
  const { Text } = Typography;
  const exportFailList = () => {
    const failData = taxInfo.tax_list?.filter(
      (item) => item.status?.toLowerCase() === "failed"
    );

    if (failData.length === 0) {
      notification.warning({
        message: "ไม่มีข้อมูลที่ล้มเหลว",
        description: "ไม่พบรายการที่มีสถานะ 'fail'",
      });
      return;
    }

    const headers = [
      "DocumentNo",
      "DocumentDate",
      "PartnerCode",
      "PartnerName",
      "PartnerAddress",
      "PartnerTax",
      "PartnerMobile",
      "TaxType",
      "TotalAmount",
      "TaxAmount",
      "TaxAmountText",
    ];
    const rows = failData.map((item, index) => [
      item.document_no || "",
      item.document_date || "",
      item.partner_code || "",
      item.partner_name || "",
      item.partner_address || "",
      `${item.partner_tax || ""}`,
      item.partner_mobile || "",
      item.tax_type || "",
      item.total_amount || "",
      item.tax_amount || "",
      item.tax_amount_text || "",
    ]);

    const wsData = [headers, ...rows];

    var wscols = [
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 25 },
      { wch: 35 },
      { wch: 25 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 35 },
    ];

    const centerStyles = {
      alignment: {
        vertical: "center",
        horizontal: "center",
      },
      border: {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
      },
      fill: { fgColor: { rgb: "E9E9E9" } },
    };

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws["!cols"] = wscols;
    ["A1", "B1", "C1", "D1", "E1", "F1", "G1", "H1", "I1", "J1", "K1"].forEach(
      (cell) => {
        ws[cell].s = centerStyles;
      }
    );

    XLSX.utils.book_append_sheet(wb, ws, "TAX Fail List");
    XLSX.writeFile(wb, "tax-fail-list.xlsx");
  };
  useEffect(() => {
    if (importStatusModal.visible) {
      setImportStatusPage(1);
      form.setFieldsValue(taxInfo);
    }
  }, [importStatusModal.visible, form, taxInfo]);

  return (
    <Modal
      title="ผลการนำเข้าเอกสาร"
      visible={importStatusModal.visible}
      width="80%"
      zIndex={1080}
      footer={[
        <Button key="export" onClick={exportFailList}>
          Export Fail List
        </Button>,
        <Button
          key="close"
          type="primary"
          onClick={() => {
            dispatch({ type: "clearTaxInfo" });
            dispatch({
              type: "setModalImportStatus",
              payload: {
                visible: false,
              },
            });
          }}
          style={{ marginLeft: 8 }}
        >
          ตกลง
        </Button>,
      ]}
      onCancel={() => {
        dispatch({ type: "clearTaxInfo" });
        dispatch({
          type: "setModalImportStatus",
          payload: { visible: false },
        });
      }}
    >
      <Form form={form} className="mb-3" layout="vertical" scrollToFirstError>
        <Divider orientation="left" style={{ marginTop: 12, marginBottom: 12 }}>
          ข้อมูลเอกสารภาษี
        </Divider>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label="ชื่อหัวข้อภาษี"
              name="tax_title"
              style={{ marginBottom: 12 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="ปีภาษี (พ.ศ.)"
              name="tax_year"
              style={{ marginBottom: 12 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label="ชื่อบริษัท"
              name="company_name"
              style={{ marginBottom: 12 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={10}>
            <Form.Item
              label="ที่อยู่บริษัท"
              name="company_address"
              style={{ marginBottom: 12 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label="รหัสผู้เสียภาษีบริษัท"
              name="company_tax"
              style={{ marginBottom: 12 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>

        <Divider orientation="left" style={{ marginTop: 8, marginBottom: 12 }}>
          ผู้ออกเอกสาร
        </Divider>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label="รหัสพนักงาน"
              name="account_code"
              style={{ marginBottom: 12 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="ชื่อพนักงาน"
              name="account_name"
              style={{ marginBottom: 12 }}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Table
        bordered
        size="small"
        scroll={{ x: "max-content" }}
        dataSource={
          taxInfo.tax_list?.map((item, idx) => ({
            ...item,
            key: idx.toString(),
          })) || []
        }
        rowKey="key"
        pagination={{
          current: importStatusPage,
          pageSize: pageSize,
          showSizeChanger: false,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
          total: taxInfo.tax_list?.length || 0,
          size: "default",
          onChange: (currPage) => setImportStatusPage(currPage),
        }}
      >
        <Table.Column
          title="#"
          key="index"
          render={(_, __, index) =>
            (importStatusPage - 1) * pageSize + index + 1
          }
        />
        <Table.Column title="เลขที่เอกสาร" dataIndex="document_no" />
        <Table.Column
          title="วันที่เอกสาร"
          dataIndex="document_date"
          render={(date) => moment(date).format("DD/MM/YYYY")}
        />
        <Table.Column title="รหัสสมาชิก" dataIndex="partner_code" />
        <Table.Column title="ชื่อ - นามสกุล" dataIndex="partner_name" />
        <Table.Column title="ที่อยู่" dataIndex="partner_address" />
        <Table.Column title="เลขประจำตัวผู้เสียภาษี" dataIndex="partner_tax" />
        <Table.Column title="เบอร์โทร" dataIndex="partner_mobile" />
        <Table.Column title="ประเภทภาษี" dataIndex="tax_type" />
        <Table.Column title="ยอดรวม" dataIndex="total_amount" />
        <Table.Column title="ภาษี" dataIndex="tax_amount" />
        <Table.Column title="ภาษี (Text)" dataIndex="tax_amount_text" />
        <Table.Column title="สถานะ" dataIndex="status" />
      </Table>
      <Row justify="space-between" className="mt-3">
        <Col>
          <span></span>
          <Text>
            <span role="img" aria-label="success">
              ✅
            </span>{" "}
            สำเร็จ:{" "}
            {
              taxInfo.tax_list?.filter((item) =>
                item.status?.toLowerCase().includes("success")
              ).length
            }{" "}
            รายการ{" | "}
            <span role="img" aria-label="fail">
              ❌
            </span>{" "}
            ไม่สำเร็จ:{" "}
            {
              taxInfo.tax_list?.filter((item) =>
                item.status?.toLowerCase().includes("failed")
              ).length
            }{" "}
            รายการ
          </Text>
        </Col>
      </Row>
    </Modal>
  );
};

export default ImportStatusModal;
